<template lang="pug">
input(
  type="file"
  :disabled="disabled"
  :name="$parent.name"
  :id="$parent.inputId || $parent.name"
  :accept="$parent.accept"
  @change="change"
  :webkitdirectory="$parent.directory && $parent.features.directory"
  :directory="$parent.directory && $parent.features.directory"
  :multiple="$parent.multiple && $parent.features.html5"
)
</template>

<script>

export default {
  name: 'input-file',
  props: {
    disabled: Boolean
  },
  methods: {
    change(e) {
      this.$destroy()
      this.$parent.addInputFile(e.target)
      // eslint-disable-next-line
      new this.constructor({
        parent: this.$parent,
        el: this.$el
      })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/core/components/edUpload/fileUploadField.vue